import { BaseContext } from '../../../utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../uicomponent';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import { ToggleButtonCSSStyle } from './togglebuttoncss';
import { ToggleButtonView } from './togglebuttonview';

export interface ToggleButtonProps extends UIComponentProps
{
    label: string;
    style: ToggleButtonCSSStyle;
    isSelected:boolean;
    onClick():void;
}
export interface ToggleButtonState extends UIComponentState
{
    label: string;
    style: ToggleButtonCSSStyle;
    isSelected:boolean;

}

export interface ToggleButtonHandler extends UIComponentHandler
{
    
}

export class ToggleButtonComponent extends UIComponentImpl<ToggleButtonProps, ToggleButtonState, UIDataModel>
{
    constructor(props: ToggleButtonProps)
    {
        super(props);

        this.state = {label: props.label, style: props.style, isSelected:props.isSelected};
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToggleButtonView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.state.style;
    }

    UNSAFE_componentWillReceiveProps(nextProps: ToggleButtonProps)
    {
        this.setState({label: nextProps.label, style: nextProps.style});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebutton/togglebuttoncomponent.tsx